var render, staticRenderFns
import script from "./PopupSell.vue?vue&type=script&lang=js"
export * from "./PopupSell.vue?vue&type=script&lang=js"
import style0 from "./PopupSell.vue?vue&type=style&index=0&id=a97c93f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c93f0",
  null
  
)

export default component.exports